import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const root = document.getElementById('root')!

const mount = () => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

// Az index.html statikus hero-héja kapjon legalább egy kifestett képkockát, mielőtt a React
// lecseréli: ha a JS a CSS-nél hamarabb ér ide (lassú hálón előfordul), a React-render lenne
// az első festés, és az FCP/LCP a JS lefutásához tolódna. Dupla rAF = a következő képkocka után.
// A rAF csak akkor fut, ha a render-blokkoló CSS már megjött — pont ezt akarjuk megvárni, ezért
// NINCS rövid időzítő-tartalék (egy 300 ms-os tartalék lassú hálón megelőzte a héj kifestését).
// Rejtett fülön a rAF nem fut → ott azonnal mountolunk; 5 s-os vész-tartalék minden más esetre.
let mounted = false
const mountOnce = () => {
  if (mounted) return
  mounted = true
  mount()
}
// Első rAF = az első képkocka (a CSS már megjött) → utána még ~150 ms, hogy a Chrome a héj szövegét
// biztosan LCP-jelöltként rögzítse (a jelölt a képkocka MEGJELENÍTÉSE után kerül be; ha a React egy
// képkockán belül cseréli a DOM-ot, a héj néha kimarad, és az LCP a React-renderre csúszik).
// A héj és a React első képkockája pixelre azonos, a 150 ms nem látszik.
if (document.visibilityState === 'hidden') {
  mountOnce()
} else {
  requestAnimationFrame(() => setTimeout(() => requestAnimationFrame(mountOnce), 150))
  setTimeout(mountOnce, 5000)
}
